import React, { forwardRef } from 'react';
import { ExcelExport, ExcelExportColumn, ExcelExportColumnGroup } from '@progress/kendo-react-excel-export';

const buildColumns = (items) => items.map(({ field, children, ...props }) => {
  if (field) {
    return <ExcelExportColumn key={field} field={field} {...props} />;
  }
  return (
    <ExcelExportColumnGroup key={props.title} {...props}>
      {buildColumns(children)}
    </ExcelExportColumnGroup>
  );
});

const CustomExcelExport = forwardRef(({
  data,
  fileName,
  columns,
}, ref) => (
  <ExcelExport ref={ref} data={data} fileName={fileName}>
    {buildColumns(columns || [])}
  </ExcelExport>
));

CustomExcelExport.displayName = 'CustomExcelExport';

export default CustomExcelExport;
